import { Component, OnInit } from '@angular/core';
import { ExhibitService } from 'src/app/_services/generatedServices';
import { ExhibitSummaryViewModel } from 'src/app/_models/generatedModels';
import { NavigationService } from 'src/app/_services/navigation-service';
import { Title } from '@angular/platform-browser';
import { AuthenticationService } from '../_services/authentication.service';

@Component({
  selector: 'bxl-my-exhibits',
  templateUrl: 'my-exhibits.component.html',
})
export class MyExhibitsComponent implements OnInit {
  initialized = false;
  exhibits: ExhibitSummaryViewModel[];
  constructor(private exhibitsService: ExhibitService, private title: Title, public auth: AuthenticationService, private nav: NavigationService) {
    this.nav.pageTitle = 'My Exhibits';
  }

  ngOnInit(): void {
    this.exhibitsService.getExhibitsForUser().subscribe((exhibits) => {
      this.exhibits = exhibits;
      this.initialized = true;
    });
  }
}
